import { useState, useRef, useEffect } from 'react'
import { QRCodeCanvas as QRCodeReact } from 'qrcode.react'
import Dialog from '@mui/material/Dialog'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { clearQrCodeModalParams, selectQrCodeModalParams, selectShowQrCodeModal } from './modalsSlice'

const QRModal = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch();
  const show = useSelector(selectShowQrCodeModal);
  const modalParams = useSelector(selectQrCodeModalParams);
  const { qrCode } = useQrCode(modalParams?.building)
  const [qrCodeUrl, setQrCodeUrl] = useState('')
  const canvasRef = useRef(null)
  
  const onClose = () => dispatch(clearQrCodeModalParams())
  
  const handleDownload = () => {
    if (!qrCodeUrl) {
      alert(t('qr_code_has_not_been_generated_yet'))
      return
    }
    const link = document.createElement('a')
    link.href = qrCodeUrl
    link.download = 'QR_Code.png'
    link.click()
  }

  useEffect(() => {
    if (qrCode && canvasRef.current) {
      const canvas = canvasRef.current.querySelector('canvas')
      if (canvas) {
        setQrCodeUrl(canvas.toDataURL())
      }
    }
  }, [qrCode])
  
  return (
    <Dialog 
      open={show} 
      onClose={onClose}
    >
      <DialogTitle>{t('qr_code_of_the_object')}</DialogTitle>
      <DialogContent ref={canvasRef}>
        {
          modalParams?.building && qrCode ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <QRCodeReact 
                value={qrCode} 
                size={256} 
                level="H" 
                includeMargin 
              />
              <Button
                onClick={handleDownload}
                color="primary"
                sx={{
                  marginTop: '16px',
                  width: '256px',
                  backgroundColor: (theme) => theme.palette.primary.main,
                  color: (theme) => theme.palette.primary.contrastText,
                  '&:hover': {
                    backgroundColor: (theme) => theme.palette.primary.dark
                  }
                }}
              >
                {t('download_qr_code')}
              </Button>
            </Box>
          ) : (
            show && (
              <Typography
                variant="h6"
                color="error"
                align="center"
                sx={{
                  padding: '20px',
                  backgroundColor: '#f8d7da',
                  borderRadius: '8px',
                  border: '1px solid #f5c2c7'
                }}
              >
                {t('qr_code_is_not_available_for_this_object')}
              </Typography>
            )
          )
        }
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          color="primary"
          sx={{
            backgroundColor: (theme) => theme.palette.primary.main,
            color: (theme) => theme.palette.primary.contrastText,
            '&:hover': {
              backgroundColor: (theme) => theme.palette.primary.dark
            },
            '&:active': {
              backgroundColor: (theme) => theme.palette.primary.light,
              transform: 'scale(0.98)',
              borderColor: (theme) => theme.palette.primary.main
            }
          }}
        >
          {t('close')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}


const useQrCode = (building) => {
  const [qrCodeValue, setQrCodeValue] = useState('')
  
  useEffect(() => {
    if (building) {
      if (building.building_type_id !== 0) {
        const sanitizeString = (str) => {
          return str
        }
        
        const buildingName = sanitizeString(building.name || building.title)
        
        const qrData = {
          building_id: building.id,
          name: buildingName
        }
        
        const qrCodeString = JSON.stringify(qrData)
        setQrCodeValue(qrCodeString)
        // onQrCodeReady(qrCodeString)
      } else {
        setQrCodeValue('')
        // onQrCodeReady('')
      }
    }
  }, [building]);
  
  return { qrCode: qrCodeValue };
}

export default QRModal
